import { ResourceFieldDirectiveModule } from '@b2b/common/directives/resourceField/resourceField';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { TODO } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { ILogService, IScope, ITimeoutService } from 'angular';

export const ResourcesEditControllerModule = angular
  .module('acme.view.application.resources.edit.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.validate',
    'acme.common.service.helpers',
    'acme.common.service.permissions',
    'acme.common.factory.notice',
    ResourceFieldDirectiveModule,
  ])
  .controller('ResourcesEditController', [
    '$scope',
    '$timeout',
    '$state',
    '$log',
    'ApiService',
    'PermissionsService',
    'ValidateService',
    'HelpersService',
    'NoticeFactory',
    function (
      $scope: IScope & { resourcesEdit: TODO },
      $timeout: ITimeoutService,
      $state: StateService,
      $log: ILogService,
      ApiService: ApiService,
      PermissionsService: PermissionsService,
      ValidateService: TODO,
      HelpersService: TODO,
      NoticeFactory: NoticeFactory
    ) {
      const ctrl = {
        notice: new NoticeFactory(),

        templateId: -1,
        removeFieldIndex: -1,
        saveFieldIndex: -1,
        showErrors: false,
        isLoading: false,

        entityType: '' as TODO,

        tmp: {
          fields: [] as TODO[],
          categories: ['Personnel', 'Facilities', 'Equipment'],
        },

        selectedResourceCategory: 'Personnel',

        model: {} as TODO,

        init: function () {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Edit Resource Template',
            buttonLeft: {
              label: '< Back',
              action: function () {
                window.history.go(-1);
              },
            },
          });

          if ($state.params.hasOwnProperty('id')) {
            ctrl.templateId = $state.params.id;
            ctrl.getTemplate(ctrl.templateId);

            $scope.$on('resourceFieldCreate::save', ctrl.onResourceFieldCreateSave);
            $scope.$on('resourceFieldCreate::save::success', ctrl.success.onResourceFieldCreateSave);
            $scope.$on('resourceFieldCreate::save::error', ctrl.error.onResourceFieldCreateSave);

            $scope.$on('resourceFieldDetail::remove', ctrl.onResourceFieldDetailRemove);
            $scope.$on('resourceFieldEdit::remove', ctrl.onResourceFieldDetailRemove);

            $scope.$on('resourceFieldCreate::cancel', ctrl.onResourceFieldCreateCancel);

            ctrl.addField();
          }
        },

        complete: function () {
          if (
            ValidateService.validate([{ len: { value: ctrl.model.name } }, { len: { value: ctrl.model.description } }])
          ) {
            ctrl.notice.hideMessages();
            $scope.$broadcast('ResourcesEditController::complete');
            ctrl.updateTemplate();
          } else {
            ctrl.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
          }
        },

        getUpdatePermission: function () {
          return 'ENTITY_TEMPLATE_' + ctrl.entityType.singular.toUpperCase() + '_UPDATE';
        },

        getDeletePermission: function () {
          return 'ENTITY_TEMPLATE_' + ctrl.entityType.singular.toUpperCase() + '_DELETE';
        },

        getTemplate: function (id) {
          ApiService.resource
            .detail(id)
            .then((response) => ctrl.success.getTemplate(response))
            .catch((response) => ctrl.error.getTemplate(response));
        },

        updateTemplate: function () {
          ctrl.notice.hideMessages();
          ctrl.model.resourceCategory = ctrl.selectedResourceCategory;
          if (PermissionsService.check(ctrl.getUpdatePermission())) {
            ApiService.resource
              .update(ctrl.model, ctrl.templateId)
              .then((response) => ctrl.success.updateTemplate(response))
              .catch((response) => ctrl.error.updateTemplate(response));
          } else {
            $scope.$emit('Permissions::error');
          }
        },

        addField: function () {
          this.tmp.fields.push({
            fieldOrder: 0,
            name: '',
            type: 'StringType',
            stringValue: null,
            stringArrayValue: null,
            numberValue: null,
            numberArrayValue: null,
            minValue: 0,
            maxValue: 1,
            hidden: false,
          });
        },

        hasModelFields: function () {
          return this.model.fields && this.model.fields.length;
        },

        /**
         * Clears tmp.fields at correct index
         *
         * @param index {Integer}
         */
        cancelField: function (index) {
          this.tmp.fields.splice(index, 1);
        },

        success: {
          getTemplate: function (response) {
            ctrl.model = response.data.resourceType;
            ctrl.selectedResourceCategory = ctrl.model.resourceCategory;
            ctrl.entityType = HelpersService.getEntityName(ctrl.model.resourceCategory.toLowerCase());

            $scope.$emit('Application::contentTitleChange', {
              title: 'Edit Resource Template',
              buttonLeft: {
                label: '< Back',
                action: function () {
                  window.history.go(-1);
                },
              },
              buttonRight: {
                label: 'Save',
                permissions: 'ENTITY_TEMPLATE_' + ctrl.entityType.singular.toUpperCase() + '_UPDATE',
                action: function () {
                  ctrl.complete();
                },
              },
            });
          },

          updateTemplate: function (response) {
            ctrl.getTemplate(ctrl.model.id);
            ctrl.notice.showSuccessMessages([{ message: 'Successfully Saved!' }], { duration: 3000 });

            $scope.$emit('ResourcesUpdateTemplate::success');
          },

          onResourceFieldCreateSave: function (e, data) {
            ctrl.tmp.fields[data.index].fieldOrder = Array.isArray(ctrl.model.fields)
              ? ctrl.model.fields.length + 1
              : 1;
            ctrl.addField();

            // Clear out the tmp field
            ctrl.tmp.fields.splice(data.index, 1);
            if (!Array.isArray(ctrl.model.fields)) {
              ctrl.model.fields = [];
            }
            // Add the field to the top of the list
            ctrl.model.fields.unshift(data.field);
          },
        },

        error: {
          getTemplate: function (response) {
            ctrl.notice.showErrorMessages([{ message: response.data.error }]);
          },

          updateTemplate: function (response) {
            ctrl.notice.showErrorMessages([{ message: response.data.error }]);
          },

          onResourceFieldCreateSave: function (e, data) {},
        },

        // Listeners
        onResourceFieldCreateSave: function (e, data) {
          // Save for callback function
          // This could break down if saveField is called consecutively before the callback fires
          //s = ctrl.tmp.fields[data.index].stringArrayValue;
          // Convert string back into array because angular makes this an array via ng-model
          //ctrl.tmp.fields[data.index].stringArrayValue = HelpersService.stringToArray(s);
          //ctrl.tmp.fields[data.index].fieldOrder = (ctrl.model.fields instanceof Array) ? ctrl.model.fields.length + 1 : 1;
          //ctrl.addField();
        },

        onResourceFieldDetailRemove: function (e, data) {
          if (PermissionsService.check(ctrl.getDeletePermission())) {
            ctrl.model.fields.splice(data.index, 1);

            for (let i = 0, ii = ctrl.model.fields.length; i < ii; i++) {
              ctrl.model.fields[i].fieldOrder = ii - i;
            }

            ApiService.resource
              .update(ctrl.model, ctrl.templateId)
              .then((response) => ctrl.success.updateTemplate(response))
              .catch((response) => ctrl.error.updateTemplate(response));
          } else {
            $scope.$emit('Permissions::error');
          }
        },

        onResourceFieldCreateCancel: function (e, data) {
          ctrl.tmp.fields.splice(data.index, 1);
        },
      };

      $scope.resourcesEdit = ctrl;
      ctrl.init();
    },
  ]).name;
